import {
  LoaderFunction,
  Navigate,
  Outlet,
  json,
  redirect,
} from 'react-router-dom';
import { api } from '../../../utils/fetchApi';
import { LOCATION_CODE_TO_ID } from '../../../utils/locations';
import { useUser } from '../../../hooks/useUser';

export const loader: LoaderFunction = async ({
  params: { countryId, locationId, resolverType = '' },
}) => {
  let url = '/api/compliance/tasks';
  const searchParams = new URLSearchParams();

  if ((!countryId && locationId) || (countryId && !locationId)) {
    return redirect(`/tasks/resolver/${resolverType}`);
  } else if (countryId && locationId) {
    const regionId = LOCATION_CODE_TO_ID[locationId.toUpperCase()];

    if (regionId) {
      searchParams.set(
        'region_id',
        LOCATION_CODE_TO_ID[locationId.toUpperCase()]
      );
    } else {
      return redirect(`/tasks/resolver/${resolverType}`);
    }
  }

  if (resolverType) {
    if (resolverType === 'setup') {
      searchParams.set('is_setup', 'true');
    } else if (resolverType === 'requirement') {
      searchParams.set('task_type', 'requirement');
    } else if (resolverType === 'question') {
      searchParams.set('task_type', 'question');
    } else {
      throw json(`"${resolverType}" is not a valid Task filter.`, {
        status: 404,
      });
    }
  }

  if (searchParams.size > 0) {
    url = `${url}?${searchParams.toString()}`;
  }

  return api({ url, method: 'GET' });
};

export const Component = () => {
  const user = useUser();

  if (user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="bg-sage-100">
      <Outlet />
    </div>
  );
};
